import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'
// import product401k from './product-401k.png'
import productAntiqueAuto from './product-antiqueauto.png'
import productATV from './product-atv.png'
import productAuto from './product-auto.png'
import productAviation from './product-aviation.png'
import productBonds from './product-bonds.png'
import productBusinessInterruption from './product-businessinterruption.png'
import productCargo from './product-cargo.png'
import productChildHealthPlus from './product-childhealthplus.png'
import productCollectibles from './product-collectibles.png'
import productCommercialAuto from './product-commercialauto.png'
// import productCommercialCrime from './product-commercialcrime.png'
import productCommercialProperty from './product-commercialproperty.png'
// import productCommercialUmbrella from './product-commercialumbrella.png'
// import productCondo from './product-condo.png'
import productCyber from './product-cyber.png'
import productDental from './product-dental.png'
// import productDirectorsOfficers from './product-directorsofficers.png'
import productDisability from './product-disability.png'
import productEarthquake from './product-earthquake.png'
import productEnvironmental from './product-environmental.png'
import productEPLI from './product-epli.png'
import productEquipmentBreakdown from './product-equipmentbreakdown.png'
import productEventInsurance from './product-eventinsurance.png'
import productFarmowner from './product-farmowner.png'
// import productFarms from './product-farms.png'
// import productFinancial from './product-financial.png'
import productFlood from './product-flood.png'
import productGeneralLiability from './product-generalliability.png'
import productGolfCart from './product-golfcart.png'
import productHealth from './product-health.png'
import productHearing from './product-hearing.png'
import productHomeowners from './product-homeowners.png'
import productIdentityTheft from './product-identitytheft.png'
// import productInlandMarine from './product-inlandmarine.png'
import productJewelry from './product-jewelry.png'
import productLandlords from './product-landlords.png'
import productLife from './product-life.png'
import productLiquor from './product-liquor.png'
import productLongTermDisability from './product-longtermdisability.png'
import productMedicare from './product-medicare.png'
import productMobileHome from './product-mobilehome.png'
import productMotorcycle from './product-motorcycle.png'
import productMotorhome from './product-motorhome.png'
import productMunicipalities from './product-municipalities.png'
import productPremises from './product-premises.png'
import productPrescriptions from './product-prescriptions.png'
// import productProductLiability from './product-premises.png'
import productProfessional from './product-professional.png'
import productRenters from './product-renters.png'
// import productRetirementPlanning from './product-retirementplanning.png'
import productShortTermDisability from './product-shorttermdisability.png'
import productSnowmobile from './product-snowmobile.png'
import productTowing from './product-towing.png'
import productTravelTrailer from './product-traveltrailer.png'
import productUmbrella from './product-umbrella.jpg'
import productUtilityLine from './product-utilityline.png'
import productVision from './product-vision.png'
import productWaterBackup from './product-waterbackup.png'
import productWatercraft from './product-watercraft.png'
import productWorkersCompensation from './product-workerscompensation.png'
import programApartments from './program-apartments.png'
import programArborists from './program-arborists.png'
import programBarbers from './program-beauticians.png'
import programBusiness from './program-business.png'
import programCarpenters from './program-carpenters.png'
import programChurches from './program-churches.png'
import programDealers from './program-dealers.png'
// import programContractors from './program-contractors.png'
import programDrywallers from './program-drywallers.png'
import programElectricians from './program-electricians.png'
import programEssential from './program-essential.png'
import programExcavators from './program-excavators.png'
import programFireDepartments from './program-firedepartments.png'
import programFlooring from './program-flooring.png'
import programGarages from './program-garages.png'
import programGeneralContractors from './program-generalcontractors.png'
import programHVAC from './program-hvac.png'
import programLandscapers from './program-landscapers.png'
import programMasons from './program-masons.png'
import programNonprofits from './program-nonprofits.png'
import programOffices from './program-offices.png'
import programPainters from './program-painters.png'
import programPlumbers from './program-plumbers.png'
import programRestaurants from './program-restaurants.png'
import programRetail from './program-retail.png'
import programRoofing from './program-roofers.png'
import programSchools from './program-schools.png'
import programSnowPlowing from './program-snowplowing.png'
import programTile from './program-tilers.png'
import programTractors from './program-tractor.png'
import programTrucking from './program-trucking.png'
import programVeterans from './program-veterans.png'
import programWindowInstallers from './program-windowinstallers.png'

export const meta: MetaFunction = () => [{ title: 'Products and Programs' }]

const products = [
	{
		id: 'antique-auto',
		type: 'Product',
		name: 'Antique Auto',
		pagePath: 'antique-car-insurance',
		image: productAntiqueAuto,
	},
	{
		id: 'apartments',
		type: 'Program',
		name: 'Apartments',
		pagePath: 'apartments',
		image: programApartments,
	},
	{
		id: 'arborists',
		type: 'Program',
		name: 'Arborists',
		pagePath: 'arborists',
		image: programArborists,
	},
	{
		id: 'atv',
		type: 'Product',
		name: 'ATV',
		pagePath: 'atv-insurance',
		image: productATV,
	},
	{
		id: 'personal-auto',
		type: 'Product',
		name: 'Auto',
		pagePath: 'auto-insurance',
		image: productAuto,
	},
	{
		id: 'aviation',
		type: 'Product',
		name: 'Aviation',
		pagePath: 'aircraft-insurance',
		image: productAviation,
	},
	{
		id: 'salons',
		type: 'Program',
		name: 'Barbers & Beauticians',
		pagePath: 'barbers-and-beauticians',
		image: programBarbers,
	},
	{
		id: 'bonds',
		type: 'Product',
		name: 'Bonds',
		pagePath: 'bonds',
		image: productBonds,
	},
	{
		id: 'business',
		type: 'Program',
		name: 'Business Insurance',
		pagePath: 'business-insurance',
		image: programBusiness,
	},
	{
		id: 'business-interruption',
		type: 'Product',
		name: 'Business Interruption',
		pagePath: 'business-interruption',
		image: productBusinessInterruption,
	},
	{
		id: 'dealers',
		type: 'Program',
		name: 'Car Dealers',
		pagePath: 'car-dealers',
		image: programDealers,
	},
	{
		id: 'cargo',
		type: 'Product',
		name: 'Cargo',
		pagePath: 'cargo-insurance',
		image: productCargo,
	},
	{
		id: 'carpenters',
		type: 'Program',
		name: 'Carpenters',
		pagePath: 'carpenters',
		image: programCarpenters,
	},
	{
		id: 'childhealthplus',
		type: 'Product',
		name: 'Child Health Plus',
		pagePath: 'child-health-plus',
		image: productChildHealthPlus,
	},
	{
		id: 'churches',
		type: 'Program',
		name: 'Churches',
		pagePath: 'churches',
		image: programChurches,
	},
	{
		id: 'collectibles',
		type: 'Product',
		name: 'Collectibles',
		pagePath: 'collectibles-insurance',
		image: productCollectibles,
	},
	{
		id: 'commercial-auto',
		type: 'Product',
		name: 'Commercial Auto',
		pagePath: 'commercial-auto-insurance',
		image: productCommercialAuto,
	},
	// {
	// 	id: 'commercial-crime',
	// 	type: 'Product',
	// 	name: 'Commercial Crime',
	// 	pagePath: 'commercial-crime',
	// 	image: productCommercialCrime,
	// },
	{
		id: 'commercial-property',
		type: 'Product',
		name: 'Commercial Property',
		pagePath: 'commercial-property',
		image: productCommercialProperty,
	},
	// {
	// 	id: 'commercial-umbrella',
	// 	type: 'Product',
	// 	name: 'Commercial Umbrella',
	// 	pagePath: 'commercial-umbrella',
	// 	image: productCommercialUmbrella,
	// },
	// {
	// 	id: 'condo',
	// 	type: 'Product',
	// 	name: 'Condos',
	// 	pagePath: 'condo-insurance',
	// 	image: productCondo,
	// },
	// {
	// 	id: 'contractors',
	// 	type: 'Program',
	// 	name: 'Contractors',
	// 	pagePath: 'contractors',
	// 	image: programContractors,
	// },
	{
		id: 'cyber',
		type: 'Product',
		name: 'Cyber',
		pagePath: 'data-breach-and-cyber-liability',
		image: productCyber,
	},
	{
		id: 'dental',
		type: 'Product',
		name: 'Dental',
		pagePath: 'dental',
		image: productDental,
	},
	// {
	// 	id: 'directorsofficers',
	// 	type: 'Product',
	// 	name: 'Directors & Officers',
	// 	pagePath: 'directors-officers-liability',
	// 	image: productDirectorsOfficers,
	// },
	{
		id: 'disability',
		type: 'Product',
		name: 'Disability',
		pagePath: 'disability-insurance',
		image: productDisability,
	},
	{
		id: 'drywallers',
		type: 'Program',
		name: 'Drywallers',
		pagePath: 'drywallers',
		image: programDrywallers,
	},
	{
		id: 'earthquake',
		type: 'Product',
		name: 'Earthquake',
		pagePath: 'earthquake-insurance',
		image: productEarthquake,
	},
	{
		id: 'electricians',
		type: 'Program',
		name: 'Electricians',
		pagePath: 'electricians',
		image: programElectricians,
	},
	{
		id: 'epli',
		type: 'Product',
		name: 'Employment Practices Liability',
		pagePath: 'employment-practices-liability',
		image: productEPLI,
	},
	{
		id: 'pollution',
		type: 'Product',
		name: 'Environmental',
		pagePath: 'environmental-practices-liability',
		image: productEnvironmental,
	},
	{
		id: 'equipment-breakdown',
		type: 'Product',
		name: 'Equipment Breakdown',
		pagePath: 'equipment-breakdown',
		image: productEquipmentBreakdown,
	},
	{
		id: 'essential',
		type: 'Program',
		name: 'Essential Plan',
		pagePath: 'essential-plan',
		image: programEssential,
	},
	{
		id: 'events',
		type: 'Product',
		name: 'Event Liability',
		pagePath: 'event-liability-insurance',
		image: productEventInsurance,
	},
	{
		id: 'excavators',
		type: 'Program',
		name: 'Excavators',
		pagePath: 'excavators',
		image: programExcavators,
	},
	{
		id: 'farmowner',
		type: 'Product',
		name: 'Farmowner',
		pagePath: 'farms',
		image: productFarmowner,
	},
	// {
	// 	id: 'financial',
	// 	type: 'Product',
	// 	name: 'Financial Planning',
	// 	pagePath: 'financial-planning',
	// 	image: productFinancial,
	// },
	{
		id: 'fire-departments',
		type: 'Program',
		name: 'Fire Departments',
		pagePath: 'fire-departments',
		image: programFireDepartments,
	},
	{
		id: 'flood',
		type: 'Product',
		name: 'Flood',
		pagePath: 'flood-insurance',
		image: productFlood,
	},
	{
		id: 'flooring',
		type: 'Program',
		name: 'Flooring',
		pagePath: 'flooring',
		image: programFlooring,
	},
	{
		id: 'garages',
		type: 'Program',
		name: 'Garages',
		pagePath: 'garages',
		image: programGarages,
	},
	{
		id: 'general-contractors',
		type: 'Program',
		name: 'General Contractors',
		pagePath: 'general-contractors',
		image: programGeneralContractors,
	},
	{
		id: 'general-liability',
		type: 'Product',
		name: 'General Liability',
		pagePath: 'general-liability-insurance',
		image: productGeneralLiability,
	},
	{
		id: 'golf-cart',
		type: 'Product',
		name: 'Golf Cart',
		pagePath: 'golf-cart-insurance',
		image: productGolfCart,
	},
	{
		id: 'health',
		type: 'Product',
		name: 'Health',
		pagePath: 'health-insurance',
		image: productHealth,
	},
	{
		id: 'hearing',
		type: 'Product',
		name: 'Hearing',
		pagePath: 'hearing',
		image: productHearing,
	},
	{
		id: 'hvac',
		type: 'Program',
		name: 'Heating & Cooling (HVAC)',
		pagePath: 'heating-and-cooling-hvac',
		image: programHVAC,
	},
	{
		id: 'homeowners',
		type: 'Product',
		name: 'Homeowners',
		pagePath: 'homeowners-insurance',
		image: productHomeowners,
	},
	{
		id: 'idtheft',
		type: 'Product',
		name: 'Identity Theft',
		pagePath: 'identity-theft',
		image: productIdentityTheft,
	},
	// {
	// 	id: 'inlandmarine',
	// 	type: 'Product',
	// 	name: 'Inland Marine',
	// 	pagePath: 'inland-marine',
	// 	image: productInlandMarine,
	// },
	{
		id: 'jewelry',
		type: 'Product',
		name: 'Jewelry',
		pagePath: 'jewelry-insurance',
		image: productJewelry,
	},
	{
		id: 'landlords',
		type: 'Product',
		name: 'Landlords',
		pagePath: 'landlord-insurance',
		image: productLandlords,
	},
	{
		id: 'landscapers',
		type: 'Program',
		name: 'Landscapers',
		pagePath: 'landscapers',
		image: programLandscapers,
	},
	{
		id: 'life',
		type: 'Product',
		name: 'Life',
		pagePath: 'life',
		image: productLife,
	},
	{
		id: 'liquor',
		type: 'Product',
		name: 'Liquor Liability',
		pagePath: 'liquor-liability',
		image: productLiquor,
	},
	{
		id: 'ltd',
		type: 'Product',
		name: 'Long-term Disability',
		pagePath: 'long-term-disability',
		image: productLongTermDisability,
	},
	{
		id: 'masons',
		type: 'Program',
		name: 'Masons',
		pagePath: 'masons',
		image: programMasons,
	},
	{
		id: 'medicare',
		type: 'Program',
		name: 'Medicare Insurance',
		pagePath: 'medicare',
		image: productMedicare,
	},
	{
		id: 'mapd',
		type: 'Product',
		name: 'Medicare Advantage',
		pagePath: 'medicare-advantage',
		image: productMedicare,
	},
	{
		id: 'medigap',
		type: 'Product',
		name: 'Medicare Supplement',
		pagePath: 'medicare-supplement',
		image: productMedicare,
	},
	{
		id: 'mobilehome',
		type: 'Product',
		name: 'Mobile home',
		pagePath: 'mobile-home-insurance',
		image: productMobileHome,
	},
	{
		id: 'motorcycle',
		type: 'Product',
		name: 'Motorcycle',
		pagePath: 'motorcycles',
		image: productMotorcycle,
	},
	{
		id: 'motorhome',
		type: 'Product',
		name: 'Motorhome',
		pagePath: 'motorhome',
		image: productMotorhome,
	},
	{
		id: 'munis',
		type: 'Product',
		name: 'Municipalities',
		pagePath: 'municipalities',
		image: productMunicipalities,
	},
	{
		id: 'nonprofits',
		type: 'Program',
		name: 'Nonprofits',
		pagePath: 'nonprofits',
		image: programNonprofits,
	},
	{
		id: 'offices',
		type: 'Program',
		name: 'Offices',
		pagePath: 'office-insurance',
		image: programOffices,
	},
	{
		id: 'painters',
		type: 'Program',
		name: 'Painters',
		pagePath: 'painters',
		image: programPainters,
	},
	{
		id: 'personalumbrella',
		type: 'Product',
		name: 'Personal Umbrella',
		pagePath: 'personal-umbrella',
		image: productUmbrella,
	},
	{
		id: 'plumbers',
		type: 'Program',
		name: 'Plumbers',
		pagePath: 'plumbers',
		image: programPlumbers,
	},
	{
		id: 'premises',
		type: 'Product',
		name: 'Premises Liability',
		pagePath: 'premises-liability',
		image: productPremises,
	},
	{
		id: 'pdp',
		type: 'Product',
		name: 'Prescription Drug Plans',
		pagePath: 'medicare-part-d-prescription-drug-plans',
		image: productPrescriptions,
	},
	// {
	// 	id: 'product-liab',
	// 	type: 'Product',
	// 	name: 'Product Liability',
	// 	pagePath: 'product-liability-insurance',
	// 	image: productProductLiability,
	// },
	{
		id: 'professional',
		type: 'Product',
		name: 'Professional Liability',
		pagePath: 'professional-liability',
		image: productProfessional,
	},
	{
		id: 'renters',
		type: 'Product',
		name: 'Renters',
		pagePath: 'renters',
		image: productRenters,
	},
	{
		id: 'restaurants',
		type: 'Program',
		name: 'Restaurants',
		pagePath: 'restaurants',
		image: programRestaurants,
	},

	{
		id: 'retail',
		type: 'Program',
		name: 'Retail',
		pagePath: 'retail-insurance',
		image: programRetail,
	},
	// {
	// 	id: 'retirement',
	// 	type: 'Product',
	// 	name: 'Retirement planning',
	// 	pagePath: 'retirement-planning',
	// 	image: productRetirementPlanning,
	// },
	{
		id: 'roofing',
		type: 'Program',
		name: 'Roofing Contractor',
		pagePath: 'roofing-insurance',
		image: programRoofing,
	},
	{
		id: 'schools',
		type: 'Program',
		name: 'Schools',
		pagePath: 'schools',
		image: programSchools,
	},
	{
		id: 'std',
		type: 'Product',
		name: 'Short-term Disability',
		pagePath: 'short-term-disability',
		image: productShortTermDisability,
	},
	{
		id: 'snowmobile',
		type: 'Product',
		name: 'Snowmoble',
		pagePath: 'snowmobile-insurance',
		image: productSnowmobile,
	},
	{
		id: 'snowplowing',
		type: 'Program',
		name: 'Snow Plowing',
		pagePath: 'snow-plowing',
		image: programSnowPlowing,
	},
	{
		id: 'tile',
		type: 'Program',
		name: 'Tile, Stone, & Marble',
		pagePath: 'tile-stone-and-marble',
		image: programTile,
	},
	{
		id: 'towing',
		type: 'Product',
		name: 'Towing / Roadside Help',
		pagePath: 'towing-and-roadside-assistance',
		image: productTowing,
	},
	{
		id: 'tractors',
		type: 'Program',
		name: 'Tractors',
		pagePath: 'tractors',
		image: programTractors,
	},
	{
		id: 'traveltrailer',
		type: 'Product',
		name: 'Travel Trailer',
		pagePath: 'travel-trailer-insurance',
		image: productTravelTrailer,
	},
	{
		id: 'trucking',
		type: 'Program',
		name: 'Trucking',
		pagePath: 'trucking',
		image: programTrucking,
	},
	{
		id: 'utilityline',
		type: 'Product',
		name: 'Utility line',
		pagePath: 'utility-line',
		image: productUtilityLine,
	},
	{
		id: 'veterans',
		type: 'Program',
		name: 'Veterans',
		pagePath: 'veterans',
		image: programVeterans,
	},
	{
		id: 'vision',
		type: 'Product',
		name: 'Vision',
		pagePath: 'vision',
		image: productVision,
	},
	{
		id: 'waterbackup',
		type: 'Product',
		name: 'Water Backup',
		pagePath: 'water-backup-insurance',
		image: productWaterBackup,
	},
	{
		id: 'watercraft',
		type: 'Product',
		name: 'Watercraft',
		pagePath: 'watercraft',
		image: productWatercraft,
	},
	{
		id: 'window',
		type: 'Program',
		name: 'Window Installers',
		pagePath: 'window-installation',
		image: programWindowInstallers,
	},
	{
		id: 'workcomp',
		type: 'Product',
		name: "Worker's Compensation",
		pagePath: 'workers-compensation',
		image: productWorkersCompensation,
	},
	// {
	// 	id: '401k',
	// 	type: 'Product',
	// 	name: '401k',
	// 	pagePath: '401k-plans',
	// 	image: product401k,
	// },
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<div className="bg-white">
				<div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
					<div className="flex items-center justify-between space-x-4">
						<h1 className="text-4xl font-black">Products and Programs</h1>
					</div>
					<p
						data-paragraph
						className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
					>
						We look at each client relationship as a long-term commitment to
						integrity and quality service. As the agency has grown and expanded
						over the past five decades, we have branched out to offer more
						products and services to meet the intricate needs of our clients.
						{/* There are five core product categories that we deal with: */}
					</p>
					{/* <table>
						<tr>
							<td className="nowrap-c">
								<Link
									to="/products/personal-insurance/"
									className="text-blue-600 underline"
									prefetch="intent"
								>
									<strong>
										Personal <br />
										&amp;
										<br /> Family
									</strong>
								</Link>
							</td>
							<td>
								Your needs may be simple or complicated, but don't worry, we've
								got you covered. You'll have peace of mind knowing that you have
								the right coverage.{' '}
								<Link
									to="/products/personal-insurance/"
									className="text-blue-600 underline"
									prefetch="intent"
								>
									Learn More
								</Link>
							</td>
						</tr>
						<tr>
							<td className="nowrap-c">
								<Link
									to="/products/business/"
									className="text-blue-600 underline"
									prefetch="intent"
								>
									<strong>Business</strong>
								</Link>
							</td>
							<td>
								As a business owner, it's important to protect your bottom line.
								We take a holistic approach as we review the needs of your
								business. We have a variety of special programs from Artisan
								Contractors to Wholesalers.{' '}
								<Link to="/products/business/">Learn More</Link>
							</td>
						</tr>
						<tr>
							<td className="nowrap-c">
								<Link
									to="/products/financial/"
									className="text-blue-600 underline"
									prefetch="intent"
								>
									<strong>
										Life Insurance <br />
										&amp;
										<br /> Financial Services
									</strong>
								</Link>
							</td>
							<td>
								Ask us how we can provide you with an evaluation of your current
								situation with life insurance &amp; financial planning. Odds are
								that over the years you've made some changes in your life. Your
								insurance program may need to be changed in order to fit your
								current needs. <Link to="/products/financial/">Learn More</Link>
							</td>
						</tr>
						<tr>
							<td className="nowrap-c">
								<Link
									to="/products/public-entities/"
									className="text-blue-600 underline"
									prefetch="intent"
								>
									<strong>Public Entities</strong>
								</Link>
							</td>
							<td>
								We're very proud of our long-standing relationship with
								Selective Insurance, one of the leading insurers of public
								entities in New York State. Selective is known for its broad
								coverage offerings. Highlights of this product category include
								municipalities, fire departments, and schools.{' '}
								<Link
									to="/products/public-entities/"
									className="text-blue-600 underline"
									prefetch="intent"
								>
									Learn More
								</Link>
							</td>
						</tr>
						<tr>
							<td className="nowrap-c">
								<Link
									to="/products/nonprofits/"
									className="text-blue-600 underline"
									prefetch="intent"
								>
									<strong>Nonprofits</strong>
								</Link>
							</td>
							<td>
								Nonprofit organizations have special needs when it comes to
								insurance. We have the products and knowledge to make sure you
								have the right coverage. Also included in this category are
								social services and churches.{' '}
								<Link
									to="/products/nonprofits/"
									prefetch="intent"
									className="text-blue-600 underline"
								>
									Learn More
								</Link>
							</td>
						</tr>
					</table> */}
					<div className="mt-6 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 sm:gap-y-10 lg:grid-cols-4">
						{products.map(product => (
							<div key={product.id} className="group relative">
								<div className="aspect-w-16 aspect-h-9 overflow-hidden rounded-lg bg-gray-100">
									<img
										src={product.image}
										alt={product.name}
										className="object-cover object-center"
									/>
									<div
										className="flex items-end p-4 opacity-0 group-hover:opacity-100"
										aria-hidden="true"
									>
										<div className="w-full rounded-md bg-white bg-opacity-75 px-4 py-2 text-center text-sm font-medium text-gray-900 backdrop-blur backdrop-filter">
											View {product.type}
										</div>
									</div>
								</div>
								<div className="mt-4 flex items-center justify-between space-x-8 text-lg font-medium text-gray-900">
									<h3>
										<Link to={product.pagePath} prefetch="intent">
											<span aria-hidden="true" className="absolute inset-0" />
											{product.name}
										</Link>
									</h3>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
			{/* <div>
				<hr />
				<p
					data-paragraph
					className="mt-6 py-3 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Securities and Investment Advisory services offered through Ameritas
					Investment Corp. (AIC) member FINRA/SIPC. AIC is not affiliated with
					Stan Steele Agency. This is not an offer of securities in any
					jurisdiction, nor is it specifically directed to a resident of any
					jurisdiction. As with any security, request a prospectus from your
					registered representative. Read it carefully before you invest or send
					money. Securities products are limited to residents of NY. Registered
					Reps of AIC do not provide legal or tax advice. Consult your attorney
					or tax professional regarding your situation.
				</p>
			</div> */}
		</main>
	)
}
